import { render, staticRenderFns } from "./EditPost.vue?vue&type=template&id=530a0827&"
import script from "./EditPost.vue?vue&type=script&lang=js&"
export * from "./EditPost.vue?vue&type=script&lang=js&"
import style0 from "./EditPost.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports